<script setup lang="ts">
import { useFetchSimilarKits } from '~/composables/product'

const props = withDefaults(
  defineProps<{
    title: string
    titleClass?: string
    isDurationVisible: boolean
    category?: string
    tag?: string
    count?: number
    itemsPerPage?: number
    showItemsOnDesktop?: number
    isMobileSlider?: boolean
    isDesktopAccordeon?: boolean
  }>(),
  {
    title: '',
    titleClass: 'legacy-h2',
    isDurationVisible: false,
    category: '',
    tag: '',
    count: 5,
    itemsPerPage: 8,
    showItemsOnDesktop: 4,
    isMobileSlider: false,
    isDesktopAccordeon: false,
  }
)
const { data: boxesEvents } = await useFetchSimilarKits(
  props.category,
  props.itemsPerPage
)
</script>
<template>
  <div v-show="boxesEvents?.data?.length">
    <ProductShowcase
      data-test-id="kit-events-section"
      :products="boxesEvents?.data"
      image-loading="eager"
      :title-h-class="titleClass"
      :title="title"
      :is-duration-visible="false"
      :is-mobile-slider="isMobileSlider"
      :is-desktop-accordeon="isDesktopAccordeon"
      :show-items-on-desktop="showItemsOnDesktop"
      algolia-insights-label="Kits - Homepage"
      class="mt-8 md:mt-16"
    />
  </div>
</template>
